
import styles from './ua.module.scss'

export default function PanelBody(props) {
  
  return <div className={styles.body + ' ' + (props.className ? styles.className : '') + ' ' + (props.padded ? styles.padded : '') + ' ' + styles[props.theme]} style={props.style || {}}>
    { props.children }
  </div>
  
}